/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M17 2.4C17 1.0745 18.0447 0 19.3333 0h1.3334C21.9553 0 23 1.0745 23 2.4v19.2c0 1.3255-1.0447 2.4-2.3333 2.4h-1.3334C18.0447 24 17 22.9255 17 21.6V2.4Zm2.3333-.3492c-.1841 0-.3333.1535-.3333.3428v19.287c0 .1893.1492.3428.3333.3428h1.3334c.1841 0 .3333-.1535.3333-.3428V2.3936c0-.1893-.1492-.3428-.3333-.3428h-1.3334Zm-16 5.9475c-.184 0-.3333.1535-.3333.3428v13.316c0 .1894.1492.3429.3333.3429h1.3334c.184 0 .3333-.1535.3333-.3429V8.3411c0-.1893-.1492-.3428-.3333-.3428H3.3333ZM1 8.3986c0-1.3255 1.0447-2.4 2.3333-2.4h1.3334C5.9553 5.9986 7 7.0731 7 8.3986V21.6C7 22.9255 5.9553 24 4.6667 24H3.3333C2.0447 24 1 22.9255 1 21.6V8.3986Zm10.3333 5.6326c-.1841 0-.3333.1536-.3333.3429v7.2791c0 .1894.1492.3429.3333.3429h1.3334c.1841 0 .3333-.1535.3333-.3429v-7.2791c0-.1893-.1492-.3429-.3333-.3429h-1.3334ZM9 14.4234c0-1.3254 1.0447-2.4 2.3333-2.4h1.3334c1.2886 0 2.3333 1.0746 2.3333 2.4V21.6c0 1.3255-1.0447 2.4-2.3333 2.4h-1.3334C10.0447 24 9 22.9255 9 21.6v-7.1766Z"
    clipRule="evenodd"
  />,
  'MenuCIODashboard'
);
